import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import CrudActionContainer from './CrudActionContainer';
import { StoreState } from '../store-interfaces';
import commonHandler from '../errorHandlers/common-handler';
import { GuidesController } from '../controllers/GuidesController';
import { GuidesPayload } from '../model/GuidesModel';

export class GuidesCRUDActions extends CrudActionContainer {
  static NAME = 'GUIDES';
  static retrieveAllSuccess = 'GUIDES_RETRIEVED_SUCCESS';

  constructor() {
    super(GuidesCRUDActions.NAME);
  }

  retrieveAll() {
    return async (dispatch: Dispatch<StoreState>) => {
      dispatch(this.busy(this.retrieveAllAction));

      try {
        const payload = await GuidesController.getAll();

        const retrieveAllSuccessAction: RetrievedAllSuccessActionType = {
          type: GuidesCRUDActions.retrieveAllSuccess,
          payload,
        };
        dispatch(retrieveAllSuccessAction);

        return retrieveAllSuccessAction;
      } catch (e) {
        return commonHandler(dispatch)(e);
      }
    };
  }
}

export type RetrievedAllSuccessActionType = {
  type: typeof GuidesCRUDActions.retrieveAllSuccess;
  payload: GuidesPayload;
};

export const guidesCRUDActions = new GuidesCRUDActions();

export const useGuidesCRUDActions = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();

  return useMemo(
    () => ({
      retrieveAll: () => dispatch(guidesCRUDActions.retrieveAll()),
    }),
    [dispatch],
  );
};
